import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { BpInput } from '../../../../shared/components/forms/input/BpInput'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { hideModal } from '../../../../app/store/reducers/AppSlice'
import clsx from 'clsx'
import styles from './AddNetworkModal.module.scss'

interface Props {
  currentNetworks: string[]
  onSubmit: (string: string) => void
}

export const AddNetworkModal = ({ currentNetworks, onSubmit }: Props) => {
  const { t } = useTranslation()
  const [value, setValue] = useState('')
  const [isFocus, setIsFocus] = useState<boolean>(false)
  const dispatch = useAppDispatch()

  return (
    <div className={clsx(styles.root)}>
      <div className={clsx(styles.headerSection)}>
        <h3 className={clsx(styles.title)}>
          {t('pages.PPCCompliance.addNetwork')}
        </h3>
      </div>
      <div className={clsx(styles.body)}>
        <BpInput
          required
          error={
            currentNetworks.some((domain) => domain.toLowerCase() === value.toLowerCase())
              ? t('notifications.existingNetwork')
              : !value && isFocus
                ? t('notifications.networkNameRequired')
                : ''
          }
          placeholder={'Network name'}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onFocus={() => setIsFocus(true)}
        />
      </div>
      <div className={clsx(styles.footer)}>
        <BpButton
          disabled={
            !value ||
            currentNetworks.some((network) => network.toLowerCase() === value.toLowerCase())
          }
          className={clsx(styles.button)}
          type='button'
          onClick={() => {
            onSubmit(value)
            dispatch(hideModal())
          }}
        >
          {t('buttons.add')}
        </BpButton>
        <BpButton theme='transparent' type='button' onClick={() => dispatch(hideModal())}>
          {t('buttons.cancel')}
        </BpButton>
      </div>
    </div>
  )
}
